import {createFileRoute} from '@tanstack/react-router';
import TournamentCreatePage from '../../../tournaments/TournamentCreatePage.tsx';

export const Route = createFileRoute('/_app/tournaments/new')({
    component: RouteComponent,
})

function RouteComponent() {
    return <TournamentCreatePage />
}
